// images.js
import bug from '../imgs/bug.png';
import dark from '../imgs/dark.png';
import dragon from '../imgs/dragon.png';
import electric from '../imgs/electric.png';
import fairy from '../imgs/fairy.png';
import fighting from '../imgs/fighting.png';
import fire from '../imgs/fire.png';
import flying from '../imgs/flying.png';
import ghost from '../imgs/ghost.png';
import grass from '../imgs/grass.png';
import ground from '../imgs/ground.png';
import ice from '../imgs/ice.png';
import normal from '../imgs/normal.png';
import poison from '../imgs/poison.png';
import psychic from '../imgs/psychic.png';
import rock from '../imgs/rock.png';
import steel from '../imgs/steel.png';
import water from '../imgs/water.png';

const images = {
	bug,
	dark,
	dragon,
	electric,
	fairy,
	fighting,
	fire,
	flying,
	ghost,
	grass,
	ground,
	ice,
	normal,
	poison,
	psychic,
	rock,
	steel,
	water,
};

export default images;

 